import { gql } from "@apollo/client";

export const GET_VEHICLES = gql`
  query GetVehicles(
    $status: String!,
    $limit: Float!,
    $page: Float
    $city: String!,
    $brand: String,
    $model: String,
    $year: Float,
    $cylinders: Float,
    $mileages: [Float!],
    $color: String,
    $marketPrice: [Float!],
    $weeks: [Float!],
    $isNewVehicle: String,
    $lenders: [String!],
    $excludeDto: VehicleExcludeDto,
    $searchText: String,
    $sort: String,
  ) {
    getAllVehicles(
      status: $status
      limit: $limit
      page: $page
      city: $city
      brand: $brand
      model: $model,
      year: $year,
      cylinders: $cylinders,
      mileages: $mileages,
      color: $color,
      marketPrice: $marketPrice,
      weeks: $weeks,
      isNewVehicle: $isNewVehicle,
      lenders: $lenders
      excludeDto: $excludeDto
      searchText: $searchText,
      sort: $sort,
    ) {
      count
      pages
      page
      filters {
        models
        years
        cc
        colors
        mileageRange
        priceRange
      }
      data {
        internalId
        isNewVehicle
        isPlatedVehicle
        isPresale
        mileage
        year
        cylindersCapacity
        maintenanceDays
        color
        marketPrice
        lenders
        location {
          city {
            name
          }
        }
        discounts {
          status
          value
          type
        }
        activeDiscount {
          type
          value
        }
        salePrices {
          weeks
          paymentWeek
          paymentWeekBeforeDiscount
          percentageIncrease
          capital
          interest
          earn
          loanAmount
          loanAmountBeforeDiscount
        }
        images {
          url
        }
        brand {
          name
        }
        model {
          name
        }
      }
    }
  }
`;
